
import Vue from 'vue'

export default Vue.extend({
  name: 'ExpiredSVG',
  props: {
    color: {
      type: String,
      required: true
    }
  }
})
